import { type GetDataIngestionSourcesResponse } from '../../types';
import { type OverallDatasetsFreshnessStatus } from '../types';

import { getDatasetAgeDays } from './get-dataset-age-days';
import { getDatasetFreshnessStatus } from './get-dataset-freshness-status';

/**
 * Determines the aggregate freshness status across all datasets by
 * checking each individual dataset's freshness.
 */
export const getOverallDatasetsFreshnessStatus = (
  datasets: GetDataIngestionSourcesResponse['sources'],
): OverallDatasetsFreshnessStatus => {
  if (datasets.length === 0) {
    return 'all_datasets_new';
  }

  const datasetStatuses = datasets.map((dataset) =>
    getDatasetFreshnessStatus(getDatasetAgeDays(dataset.updated_at)),
  );

  if (datasetStatuses.every((status) => status === 'old')) {
    return 'all_datasets_old';
  }

  if (datasetStatuses.every((status) => status === 'new')) {
    return 'all_datasets_new';
  }

  return 'some_datasets_old';
};
